import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentComponent } from '../app/components/content/content.component';
import { content } from '../app/app.routes';
// import { FullComponent } from './shared/components/layout/full/full.component';
// import { fullRoutes } from './shared/routes/full-routes';
import { LoginComponent } from '../app/pages/auth/login/login.component';
import { AdminGuard } from './shared/guard/admin.guard';
import { SignUpComponent } from './pages/sign-up/sign-up.component';
import { ForgotPasswordComponent} from './pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { KBShowComponent } from './pages/not-logged-page/knowledgebase/article/article-kb.component';
import { KBHomeComponent } from './pages/not-logged-page/knowledgebase/home/home-kb.component';
import { KBSearchComponent} from './pages/not-logged-page/knowledgebase/search/search-kb.component';
import { EditTicketComponent } from './pages/ticket/edit-ticket/edit-ticket.component';
import { SignUpConfirmationComponent } from './pages/sign-up-confirmation/sign-up-confirmation.component';
import { HealthCheckComponent } from './pages/health-check/health-check.component';
import { TicketAttachComponent } from './pages/ticket/attach/ticket-attach.component';
import { HorarioAtendimentoComponent } from './pages/chat-app/horario-atendimento/horario-atendimento.component';
import { UnexpectedErrorComponent } from './pages/unexpected-error/unexpected-error.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard/default',
    pathMatch: 'full'
  },
  {
    path: 'auth/login',
    component: LoginComponent,
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
  {
    path: 'sign-up',
    component: SignUpComponent,
  },
  {
    path: 'sign-up-confirmation/:id',
    component: SignUpConfirmationComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
  {
    path: 'kb/:menu/articles',
    component: KBShowComponent,
  },
  {
    path: 'kb/:menu/articles/:id',
    component: KBShowComponent,
  },
  {
    path: 'kb/search',
    component: KBSearchComponent,
  },
  {
    path: 'kb',
    component: KBHomeComponent,
  },
  {
    path: 'health-check',
    component: HealthCheckComponent,
  },
  {
    path: '',
    component: ContentComponent,
    children: content,
    canActivate: [AdminGuard],
    
  },
  {
    path: "tickets/:id/edit",
    component: EditTicketComponent,
    data: {
      title: "Ticket",
      breadcrumb: "edit",
    },
  },
  {
    path: "ticket/attach/:idEmpresa/:idTicket/:nomeArquivo",
    component: TicketAttachComponent,
    data: {
      title: "Ticket",
      breadcrumb: "edit",
    },
  },
  {
    path: 'whatsapp',
    loadChildren: () => import('./pages/whatsapp/whatsapp.module').then(m => m.WhatsappPageModule)
  },
  {
    path: 'chatapp/:id/horario',
    component: HorarioAtendimentoComponent
  },
  {
    path: 'error',
    component: UnexpectedErrorComponent
  },
  {
    path: '**',
    redirectTo : 'error-page/error-400',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
